import { Injectable } from '@angular/core';
import { DivisionService } from '@services/division.service';
import { BehaviorSubject } from 'rxjs';
import { CompanyServiceApi } from './company.service';
import { ContractsService } from './contracts.service';
import { ProviderServiceApi } from './provider.service';

@Injectable({
  providedIn: 'root'
})
export class AreaService {

  private option = new BehaviorSubject<string[]>([]);
  public customOption = this.option.asObservable();
  private opcion:number;
  public providerId:number;
  public areaStores:any;
  private areas = [];
  private division = [];
  private companies = [];
  private providers = [];
  private currencys = [];
  private filterArea = [];
  constructor(private divisionService: DivisionService,
    private contractService:ContractsService,
    private companysService: CompanyServiceApi,
    private providerService : ProviderServiceApi) {   
      this.init();
  }
  public changeOption(option: number): void {
    this.setOption(option);
    this.option.next(this.store(option));
  }

  public store(opcion: number):any[]{
    this.filterArea = this.areas.filter(el => el.divisionid === Number(opcion))
   return  this.filterArea.map(el => el.name)
  }
  public getStore():any[]{    
   return this.areas
  }
  public getDivision(flag?):any[]{    
    return flag ? this.division.map(el => { return {id:el.id, text:el.name} }) : this.division;
  }
  public getCompanies(flag?):any[]{    
    return flag ? this.companies.map(el => { return {id:el.id, name:el.name} }) : this.companies;
  }
  public getProviders(flag?):any[]{    
    return flag ? this.providers.map(el => { return {id:el.id, name:el.name} }) : this.providers;
  }
  public getCurrencys():any[]{    
    return this.currencys
  }
  public getOption():number{
    return this.opcion
  }
  public setOption(opcion:number){    
    this.opcion = opcion;
  }
  public init(){
    this.divisionService.getAllAreaStore().subscribe(response => {
      this.areas = response['result'];
    })
    this.divisionService.getAllDivisions().subscribe(response => {
      this.division = response['result'];
    })
    this.companysService.getCompanies().subscribe(response => {
      this.companies = response['result']; 
    })
    this.providerService.getProviderAll().subscribe(response => {
      this.providers = response['result']; 
    })
    this.contractService.getAllCurrencys().subscribe(response => {
      this.currencys = response['result'];
    })
  }
  public setProviderId(index:number){    
    this.providerId = index;
  }
  public setType(item:any){    
    this.areaStores = item;
  }
}
